import config from '../config/config';
import qs from 'qs';

export const getIndexFromUrl = () => {
	const parsed = qs.parse( window.location.search.slice( 1 ) );
	// type=neighborhoods || type=plan-homes
	const indexFromUrl = parsed.type;
	if ( parsed.type ) {
		return indexFromUrl.includes( 'home' ) ? 'homes' : 'neighborhoods';
	}
	return config.ALGOLIA_INDEX_DEFAULT;
};

export const getIndexFromUrlWithEnv = () => {
	return `${ config.ALGOLA_ENV }_${ getIndexFromUrl() }`;
};

export const getUrlParts = () => {
	return window.location.href.match( /^(.*?)\/find-your-home/ );
};

// Title: Discover New Homes by Tri Pointe Homes in {city}/{submarket}, {full state name}
export const getTitleFromWindow = () => {
	const { stateAsLocation, submarket, cities } = window.algoliaSearchState;
	const title = config.DEFAULT_SEARCH_META_TITLE;

	if ( submarket.submarket ) {
		return `${ title } in ${ submarket.submarket }, ${ cities[ 0 ] ? `${ cities[ 0 ] }/` : '' }${ submarket.state }`;
	}
	if ( stateAsLocation.name ) {
		return `${ title } in ${ cities[ 0 ] ? `${ cities[ 0 ] }, ` : '' }${ stateAsLocation.name }`;
	}
	return title;
};

export const getCanonicalFromWindow = () => {
	const { index, stateAsLocation, submarket } = window.algoliaSearchState;
	const firstSegment = `${ window.location.origin }/${ config.DEFAULT_SEARCH_URL_PATH }`;
	const type = index.includes( 'home' ) ? 'home-plans' : 'neighborhoods';

	if ( submarket.submarket ) {
		return `${ firstSegment }${ submarket.stateAbbreviation.toLowerCase() }/${ submarket.slug }/?type=${ type }`;
	}
	if ( stateAsLocation.name ) {
		return `${ firstSegment }${ stateAsLocation.abbr.toLowerCase() }/?type=${ type }`;
	}
	return firstSegment;
};

// Description:
// Discover your dream home in {city}/{submarket}, {full state name}!
// Explore a wide range of Neighborhoods and homes tailored to your preferences. Begin your journey with us and experience the joy of homeownership in {city}/{submarket}, {full state name}.
export const getDescFromWindow = () => {
	const { stateAsLocation, submarket, cities } = window.algoliaSearchState;
	// only use the first city in the list

	if ( submarket.submarket ) {
		const city = cities[ 0 ] ? `${ cities[ 0 ] }/` : '';
		return `${ config.DEFAULT_SEARCH_META_DESC_LINE_1 } in ${ city }${ submarket.submarket }, ${ submarket.state }! ${ config.DEFAULT_SEARCH_META_DESC_LINE_2 } in ${ city }${ submarket.submarket }, ${ submarket.state }.`;
	}
	if ( stateAsLocation.name ) {
		const city = cities[ 0 ] ? `${ cities[ 0 ] }, ` : '';
		return `${ config.DEFAULT_SEARCH_META_DESC_LINE_1 } in ${ city }${ stateAsLocation.name }! ${ config.DEFAULT_SEARCH_META_DESC_LINE_2 } in  ${ city }${ stateAsLocation.name }.`;
	}
	return `${ config.DEFAULT_SEARCH_META_DESC_LINE_1 }! ${ config.DEFAULT_SEARCH_META_DESC_LINE_2 }.`;
};
